import React from "react";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const ExploreLiveItem = props => {
  const { listData } = props;

  const counterRender = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <>Live Now</>;
    } else {
      return (
        <>
          Live in {days ? <> {days < 10 ? "0" + days : days} day </> : null}
          {hours || days ? <>{hours < 10 ? "0" + hours : hours} hr </> : null}
          {minutes < 10 ? "0" + minutes : minutes} min{" "}
          {seconds < 10 ? "0" + seconds : seconds} sec
        </>
      );
    }
  };
  return (
    <Link
      to={listData.eventMeetingLink}
      className="event-page-explore-content-live"
    >
      <div className="event-page-explore-content-live-media">
        <img src={listData?.eventCover} alt={listData?.eventName} />
      </div>
      <div className="event-page-explore-content-live-overlay">
        <div className="event-page-explore-content-live-btn">
          <Countdown date={listData?.eventDate} renderer={counterRender} />
        </div>
        <div className="event-page-explore-content-live-content">
          <div className="event-page-explore-content-live-hosted">
            {listData?.hostedBy
              ? listData?.hostedBy.map((item, index) => (
                  <React.Fragment key={index}>
                    {item?.orgName}
                    {index !== listData?.length - 1 && ", "}
                  </React.Fragment>
                ))
              : listData?.eventHostBy}
          </div>
          <div
            className="event-page-explore-content-live-heading"
            title={listData?.eventName}
          >
            {listData?.eventName}
          </div>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            className="events6ix-btn events6ix-btn-primary"
          >
            WATCH LIVE
          </Button>
        </div>
      </div>
    </Link>
  );
};

export default ExploreLiveItem;
